import React from 'react';
import { RiBankLine } from "react-icons/ri"; // This is just a placeholder, replace with the correct icon
import './FixedButton.scss';

const FixedButton = () => {
  return (
    <div className="fixed-button">
      <div className="icon-wrapper">
        <RiBankLine /> {/* Replace with the correct icon */}
      </div>
      <span>deposit</span> {/* Replace text accordingly */}
    </div>
  );
};

export default FixedButton;
